// Desativar auto-descoberta do Dropzone para evitar conflitos
Dropzone.autoDiscover = false;

const billsForm = $('#bills-dropzone');

if (billsForm.length) {
  const dropzoneBills = new Dropzone('#' + billsForm.prop('id'), {
    url: billsForm.prop('action'),
    method: "post",
    paramName: "file",
    acceptedFiles: billsForm.data('accept') || ".csv,.xlsx,.xls",
    maxFilesize: billsForm.data('max-filesize') || 2, // Tamanho máximo (em MB)
    headers: {
      "X-CSRF-TOKEN": $('meta[name="csrf-token"]').prop('content'),
    },
    maxFiles: 1,
    dictDefaultMessage: "Arraste e solte o arquivo aqui ou clique para selecionar.",
    dictFileTooBig: "O arquivo é muito grande ({{filesize}} MB). Tamanho máximo permitido: {{maxFilesize}} MB.",
    dictInvalidFileType: "Tipo de arquivo inválido. Apenas arquivos do tipo: {{acceptedFiles}}.",
    dictMaxFilesExceeded: "Você só pode enviar um arquivo. Atualize a página e tente novamente",

    init: function () {

      this.on("success", function (file, response) {
        Swal.fire({
          title: 'Sucesso!',
          text: 'Arquivo enviado com sucesso!',
          icon: 'success',
          showCancelButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
          confirmButtonText: 'Ok',
        }).then((result) => {
          if (result.isConfirmed) {
            // Redirecionar apenas quando "Ok" for clicado
            location.href = response.redirectTo;
          }
        });
      });

      this.on("error", function (file, errorMessage) {
        if (typeof errorMessage === "object") {
          errorMessage = errorMessage.message;
        }

        Swal.fire({
          title: 'Erro ao enviar o arquivo!',
          text: errorMessage,
          icon: 'error',
          confirmButtonText: 'Ok',
        });
      });

      this.on("queuecomplete", function () {
        console.log("Todos os arquivos foram processados.");
      });
    },
  });
}
